import { ConfType } from "../types";
import { toTitleCase } from "./toTitleCase";

export const confTypeToString = (type: ConfType) =>
  type === ConfType.lshc ? "LSHC" : toTitleCase(type);
